import LOCALSTORAGE from "./constants/localStorage";
export default function cacheDocumentData(data: {
  field: string;
  document_type: string;
  value: string;
}) {
  let cachedData = JSON.parse(
    localStorage.getItem(LOCALSTORAGE.DOCUMENTS_DATA)
  );
  if (!cachedData) {
    cachedData = {
      [data.document_type]: {
        [data.field]: data.value,
      },
    };
  } else {
    // cachedData.[data.document_type].[data.field] = data;

    if (data.value === "") {
      delete cachedData[data.document_type][data.field];
      if (Object.keys(cachedData[data.document_type]).length === 0) {
        delete cachedData[data.document_type];
      }
    }else{
      cachedData = {
        ...cachedData,
        [data.document_type]: {
          ...cachedData[data.document_type],
          [data.field]: data.value,
        },
      }
    }

  }

  localStorage.setItem(LOCALSTORAGE.DOCUMENTS_DATA, JSON.stringify(cachedData));
}

export function removeCacheDocumentData(document_type: string) {
  let cachedData = JSON.parse(
    localStorage.getItem(LOCALSTORAGE.DOCUMENTS_DATA)
  );
  if (!cachedData) return
  if (!cachedData[document_type]) return
  if (cachedData[document_type]) {
    delete cachedData[document_type]
  }

  localStorage.setItem(LOCALSTORAGE.DOCUMENTS_DATA, JSON.stringify(cachedData));
}
